import { render, staticRenderFns } from "./ItemLain.vue?vue&type=template&id=08784737&scoped=true&"
import script from "./ItemLain.vue?vue&type=script&lang=js&"
export * from "./ItemLain.vue?vue&type=script&lang=js&"
import style0 from "./ItemLain.vue?vue&type=style&index=0&id=08784737&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08784737",
  null
  
)

export default component.exports